const EXPIRED = 'Thu, 01 Jan 1970 00:00:00 GMT'

/**
 * Cookies written before this helper set `path=/` were scoped to the document
 * directory of whatever page wrote them (e.g. `/checkout`). Such a duplicate
 * still path-prefix-matches deeper routes, shadows the `path=/` cookie in
 * `document.cookie` order, and cannot be overwritten by a `path=/` write — so
 * every ancestor path is expired explicitly, otherwise the repair never
 * converges when it runs from a deeper page.
 */
const expirePathScopedDuplicates = (name: string) => {
  const segments = window.location.pathname.split('/').filter(Boolean)
  let path = ''

  document.cookie = `${name}=; expires=${EXPIRED}; path=/`

  segments.forEach(segment => {
    path += `/${segment}`
    document.cookie = `${name}=; expires=${EXPIRED}; path=${path}`
  })
}

const setCookie = (name: string, value: string, days?: number) => {
  if (typeof window === 'undefined') return

  expirePathScopedDuplicates(name)

  const attributes = ['path=/']

  if (days) {
    const date = new Date()
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000)) // `days` in milliseconds
    attributes.unshift(`expires=${date.toUTCString()}`)
  }

  // Attributes must be `;`-separated, otherwise the browser stores them as part
  // of the value (`lang=es expires=Fri, …`) and never honours expiry or path.
  document.cookie = `${name}=${encodeURIComponent(value || '')}; ${attributes.join('; ')}`
}

const getClientCookie = (name: string) => {
  const isClientSide = typeof window !== 'undefined'
  if (!isClientSide) return null
  const nameEQ = `${name}=`
  const cookie = document.cookie
    .split(';')
    .map(cookie => cookie.trim())
    .find(cookie => cookie.startsWith(nameEQ))

  return cookie ? decodeURIComponent(cookie.substring(nameEQ.length).split(';')[0]) : null
}

export {
  setCookie,
  getClientCookie
}
